export default "__VITE_ASSET__JdGM4osg__"